import { css } from "@emotion/core";
import { FONTS } from "shared/styles/base";

export const somethingWentWrongStyles = css`
    text-align: center;
    color: #000;
    padding: 80px;

    .icon-danger {
        font-size: 50px;
        margin-bottom: 10px;
    }

    .info {
        font: 500 1.42rem/1.42rem ${FONTS.CERA};
        margin: 40px 0;
    }

    .cta {
        width: 164px;
        height: 40px;
        background-color: #000;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font: 500 1rem/1rem ${FONTS.CERA};
        border: 1px solid #000;
        border-radius: 2px;
        cursor: pointer;
        text-decoration: none;
    }
`;
